import { render, staticRenderFns } from "./CalculateSalaryProcessLevyLock.vue?vue&type=template&id=634e5461&"
import script from "./CalculateSalaryProcessLevyLock.vue?vue&type=script&lang=js&"
export * from "./CalculateSalaryProcessLevyLock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports